import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import moment from "moment";
import { uploadActionPlanEvaluationMonitor } from "../../../redux/evaluacion_desempenio/EvaluationMonitor/actions";

/**
 * Props:
 *  - show: boolean
 *  - handleClose: fn
 *  - evaluationId: number | null
 *  - fichaEmpleado: object (opcional, para descripción)
 *  - onUploaded: fn callback cuando el upload fue exitoso
 */
const ActionPlanModal = ({ show, handleClose, evaluationId, fichaEmpleado, onUploaded }) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const onFileChange = (e) => {
    setError("");
    const f = e.target.files && e.target.files[0];
    setFile(f || null);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError("Seleccione un archivo.");
      return;
    }
    if (!evaluationId) {
      setError("No se encontró la evaluación");
      return;
    }
    setUploading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("archivo", file);
      formData.append("nombre", file.name);
      formData.append("descripcion", `EvaluacionObjetivos-${fichaEmpleado?.codigo || ""}-${moment().format("DDMMYYYY")}`);
      formData.append("empleado_evaluacion", evaluationId);
      formData.append("estado", true);
      await dispatch(uploadActionPlanEvaluationMonitor(formData));
      // Callback para que el padre recargue la lista
      if (onUploaded) onUploaded();
    } catch (err) {
      setError(err?.message || "Ocurrió un error al subir el archivo.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Form onSubmit={onSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Subir Plan de Acción</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group>
            <Form.Label>Archivo</Form.Label>
            <Form.Control
              type="file"
              onChange={onFileChange}
              accept="*/*"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="rounded-pill" variant="secondary" onClick={handleClose} disabled={uploading}>
            Cerrar
          </Button>
          <Button className="rounded-pill" variant="primary" type="submit" disabled={uploading}>
            {uploading && <Spinner as="span" animation="border" size="sm" className="mr-2" />} Subir
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ActionPlanModal;